import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const CLAVE = "gmr-tema";

/**
 * Cambio de tema claro/oscuro.
 *
 * Arranca en "sistema": sin `data-theme` en la raíz, manda
 * `prefers-color-scheme`. En cuanto el visitante elige, se estampa
 * `data-theme` y su elección gana sobre el sistema, aquí y al volver.
 */
const leerPreferencia = () => {
  if (typeof window === "undefined") return null;
  const guardado = window.localStorage.getItem(CLAVE);
  return guardado === "dark" || guardado === "light" ? guardado : null;
};

const esOscuroAhora = () =>
  document.documentElement.dataset.theme
    ? document.documentElement.dataset.theme === "dark"
    : window.matchMedia("(prefers-color-scheme: dark)").matches;

const ThemeToggle = () => {
  const [tema, setTema] = useState(leerPreferencia);
  const [oscuro, setOscuro] = useState(false);

  useEffect(() => {
    const raiz = document.documentElement;
    if (tema) {
      raiz.dataset.theme = tema;
      window.localStorage.setItem(CLAVE, tema);
    } else {
      delete raiz.dataset.theme;
      window.localStorage.removeItem(CLAVE);
    }
    setOscuro(esOscuroAhora());
  }, [tema]);

  // Mientras nadie haya elegido, el botón sigue al sistema si este cambia.
  useEffect(() => {
    if (tema) return undefined;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const alCambiar = () => setOscuro(mq.matches);
    mq.addEventListener("change", alCambiar);
    return () => mq.removeEventListener("change", alCambiar);
  }, [tema]);

  const Icono = oscuro ? Sun : Moon;

  return (
    <button
      type="button"
      onClick={() => setTema(oscuro ? "light" : "dark")}
      aria-label={oscuro ? "Cambiar a tema claro" : "Cambiar a tema oscuro"}
      data-testid="theme-toggle"
      className="grid h-9 w-9 place-items-center rounded-full border border-[var(--gm-line-soft)] text-[var(--gm-muted)] transition-colors duration-300 hover:border-[var(--gm-accent)] hover:text-[var(--gm-accent)]"
    >
      <Icono className="h-4 w-4" strokeWidth={1.6} />
    </button>
  );
};

export default ThemeToggle;
